// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as BestDealsActions } from '../duck';
import { actions as AlertActions } from '../../alert/duck';
import BestDeals from '../components/BestDeals'

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    isFetchingDeals: state.deals.isFetchingDeals,
    deals: state.deals.deals,
    error: state.deals.error,
    dealsPage: state.deals.dealsPage,
    dealsPageCanAsk: state.deals.dealsPageCanAsk,
    localValues: state.localValues,
    locale: state.locale,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ ...BestDealsActions, ...AlertActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BestDeals);



// WEBPACK FOOTER //
// ./src/modules/best-deals/containers/BestDealsContainer.js